export const tutorialStorageKeys = {
  seen: (barbershopId) => `barberflow_tutorial_seen_${barbershopId}`,
  checklist: (barbershopId) => `barberflow_onboarding_checklist_${barbershopId}`
};

export const tutorialSteps = [
  {
    popover: {
      title: 'Bem-vindo ao BarberFlow',
      description: 'Este tour mostra como configurar sua barbearia, conectar WhatsApp, criar servicos e publicar sua agenda.',
      side: 'bottom',
      align: 'center'
    }
  },
  {
    element: '[data-tour="sidebar"]',
    popover: {
      title: 'Menu lateral',
      description: 'Aqui ficam todas as areas principais: agenda, barbeiros, servicos, WhatsApp, pagamentos e configuracoes.',
      side: 'right',
      align: 'start'
    }
  },
  {
    element: '[data-tour="dashboard-home"]',
    popover: {
      title: 'Dashboard principal',
      description: 'Acompanhe agendamentos do dia, confirmados, cancelados e faturamento em tempo real.',
      side: 'bottom',
      align: 'start'
    }
  },
  {
    element: '[data-tour="appointments-card"]',
    popover: {
      title: 'Agenda do dia',
      description: 'Veja os clientes de hoje e use as acoes rapidas para iniciar, concluir ou cancelar atendimentos.',
      side: 'top',
      align: 'start'
    }
  },
  {
    element: '[data-tour="nav-whatsapp"]',
    popover: {
      title: 'Conectar WhatsApp',
      description: 'Entre aqui para conectar o WhatsApp Web da barbearia e ativar mensagens automaticas.',
      side: 'right',
      align: 'center'
    }
  },
  {
    element: '[data-tour="nav-barbers"]',
    popover: {
      title: 'Barbeiros',
      description: 'Cadastre profissionais, foto, WhatsApp e defina quem aparece na pagina publica.',
      side: 'right',
      align: 'center'
    }
  },
  {
    element: '[data-tour="nav-services"]',
    popover: {
      title: 'Servicos',
      description: 'Configure cortes, barba, precos, duracao, fotos e extras para o cliente escolher.',
      side: 'right',
      align: 'center'
    }
  },
  {
    element: '[data-tour="nav-appointments"]',
    popover: {
      title: 'Agendamentos',
      description: 'Acompanhe a agenda por dia, semana ou mes, filtrando por barbeiro e status.',
      side: 'right',
      align: 'center'
    }
  },
  {
    element: '[data-tour="public-page-button"]',
    popover: {
      title: 'Agenda publica',
      description: 'Este botao abre a pagina publica que seus clientes usam para escolher servico e horario.',
      side: 'bottom',
      align: 'end'
    }
  },
  {
    element: '[data-tour="nav-plans"]',
    popover: {
      title: 'Planos de clientes',
      description: 'Crie assinaturas mensais para clientes recorrentes marcarem horarios com plano ativo.',
      side: 'right',
      align: 'center'
    }
  },
  {
    element: '[data-tour="nav-services"]',
    popover: {
      title: 'Order bump',
      description: 'Nos servicos voce pode ativar extras como barba, sobrancelha ou hidratacao para aumentar o valor do pedido.',
      side: 'right',
      align: 'center'
    }
  },
  {
    element: '[data-tour="nav-settings"]',
    popover: {
      title: 'Reviews, horarios e QR Code',
      description: 'Em configuracoes voce ajusta avaliacoes, endereco, horarios de funcionamento e QR Code da pagina publica.',
      side: 'right',
      align: 'center'
    }
  },
  {
    element: '[data-tour="nav-mercado-pago"]',
    popover: {
      title: 'Pagamentos e checkout',
      description: 'Configure Mercado Pago para Pix, sinais, planos e renovacoes funcionarem no fluxo certo.',
      side: 'right',
      align: 'center'
    }
  },
  {
    element: '[data-tour="tutorial-button"]',
    popover: {
      title: 'Ver tutorial novamente',
      description: 'Sempre que quiser, clique aqui para reiniciar este tour guiado.',
      side: 'bottom',
      align: 'end'
    }
  },
  {
    popover: {
      title: 'Setup finalizado',
      description: 'Agora configure WhatsApp, barbeiros, servicos e compartilhe sua agenda publica para comecar a receber agendamentos.',
      side: 'bottom',
      align: 'center'
    }
  }
];

export const onboardingChecklistItems = [
  {
    id: 'whatsapp',
    label: 'Conectar WhatsApp',
    description: 'Ative notificacoes automaticas para clientes e barbeiros.',
    target: 'whatsapp',
    match: ({ whatsappConnected }) => !!whatsappConnected
  },
  {
    id: 'barbers',
    label: 'Criar primeiro barbeiro',
    description: 'Cadastre profissionais que atendem na barbearia.',
    target: 'barbeiros',
    match: ({ barbersCount }) => Number(barbersCount || 0) > 0
  },
  {
    id: 'services',
    label: 'Criar primeiro servico',
    description: 'Adicione corte, barba ou combos com preco e duracao.',
    target: 'servicos',
    match: ({ servicesCount }) => Number(servicesCount || 0) > 0
  },
  {
    id: 'public_page',
    label: 'Publicar agenda',
    description: 'Abra e compartilhe sua pagina publica com clientes.',
    target: null,
    match: ({ publicPageVisited }) => !!publicPageVisited
  },
  {
    id: 'first_test',
    label: 'Fazer primeiro teste',
    description: 'Crie um agendamento teste e valide o fluxo completo.',
    target: 'agendamentos',
    match: ({ appointmentsCount }) => Number(appointmentsCount || 0) > 0
  }
];
